import React, { useContext } from "react";
import { ThemeContext } from "../../../../../context/ThemeContext";

const DepositHistoryTable = ({
  depositHistory,
  formatMoney,
  formatDate,
}) => {
  const { theme } = useContext(ThemeContext); // ← Theme Context

  const thStyle = {
    textAlign: "left",
    padding: 14,
    fontSize: 12,
    fontWeight: 700,
    color: theme.primary,
    borderBottom: `1px solid ${theme.border}`,
    background: theme.surfaceLighter,
    whiteSpace: "nowrap",
  };

  const tdStyle = {
    padding: 14,
    fontSize: 13,
    color: theme.textPrimary,
    borderBottom: `1px solid ${theme.border}`,
  };

  return (
    <div
      style={{
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: 15,
        overflow: "hidden",
        marginTop: 25,
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: 18,
          fontWeight: "bold",
          fontSize: 18,
          color: theme.textPrimary,
          borderBottom: `1px solid ${theme.border}`,
          background: theme.surfaceLighter,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span>🏦 Deposit History</span>
        <span
          style={{
            fontSize: 12,
            fontWeight: 500,
            color: theme.textMuted,
            background: `${theme.primary}1a`,
            padding: "4px 12px",
            borderRadius: 12,
          }}
        >
          Total: {depositHistory.length}
        </span>
      </div>

      {/* Empty State */}
      {depositHistory.length === 0 ? (
        <div
          style={{
            padding: 60,
            textAlign: "center",
            color: theme.textMuted,
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 12 }}>🏦</div>
          <h3
            style={{
              color: theme.textPrimary,
              marginBottom: 8,
              fontSize: 16,
              fontWeight: 600,
            }}
          >
            No Deposit History Found
          </h3>
          <p style={{ color: theme.textMuted, fontSize: 13 }}>
            This driver hasn't deposited any cash yet
          </p>
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: 900,
            }}
          >
            <thead>
              <tr>
                <th style={thStyle}>Order ID</th>
                <th style={thStyle}>Customer</th>
                <th style={thStyle}>Restaurant</th>
                <th style={thStyle}>Amount</th>
                <th style={thStyle}>Collected By</th>
                <th style={thStyle}>Verified By</th>
                <th style={thStyle}>Verified At</th>
                <th style={thStyle}>Status</th>
              </tr>
            </thead>
            <tbody>
              {depositHistory.map((item) => (
                <tr
                  key={item.deposit_id}
                  style={{
                    transition: "background 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background =
                      theme.surfaceHover || `${theme.primary}08`)
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  {/* Order ID */}
                  <td
                    style={{
                      ...tdStyle,
                      fontWeight: 600,
                      fontFamily: "monospace",
                      color: theme.primary,
                      fontSize: 12,
                    }}
                  >
                    #{item.order_id}
                  </td>

                  {/* Customer */}
                  <td style={{ ...tdStyle, color: theme.textSecondary }}>
                    {item.receiver_name || "-"}
                  </td>

                  {/* Restaurant */}
                  <td style={{ ...tdStyle, color: theme.textSecondary }}>
                    {item.restaurant_name || "-"}
                  </td>

                  {/* Amount */}
                  <td
                    style={{
                      ...tdStyle,
                      color: theme.success,
                      fontWeight: "bold",
                    }}
                  >
                    {formatMoney(item.amount)}
                  </td>

                  {/* Collected By */}
                  <td style={{ ...tdStyle, color: theme.textSecondary }}>
                    {item.collected_by_admin_name || "—"}
                  </td>

                  {/* Verified By */}
                  <td style={{ ...tdStyle, color: theme.textSecondary }}>
                    {item.verified_by_admin_name || "—"}
                  </td>

                  {/* Verified At */}
                  <td style={{ ...tdStyle, color: theme.textMuted, fontSize: 12 }}>
                    {formatDate(item.verified_at)}
                  </td>

                  {/* Status Badge */}
                  <td style={tdStyle}>
                    <span
                      style={{
                        padding: "5px 12px",
                        borderRadius: 20,
                        fontSize: 11,
                        fontWeight: 600,
                        background: `${theme.success}1a`,
                        color: theme.success,
                        display: "inline-block",
                      }}
                    >
                      ✓ Verified
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DepositHistoryTable;